import api from "./api";

const route = "/invoices";

export default {
  getInvoices: () => api.get(route),
};
